module.exports = __webpack_public_path__ + "static/img/pic_coop01@2x.181f01d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/anchorOperation/skillsTaining/pic_coop01@2x.png
// module id = 1xFU
// module chunks = 0